import { Component, Input, EventEmitter, Output, OnInit, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DynamicComponent, HisAuthService } from 'hisng';

import { Project } from '../../../finance/model/project/project';
import { Habilitation } from '../../../doctoral/model/habilitation';
import { Publication } from '../../../publication/model/publication';
import { ResearchContract } from '../../model/finance/research-contract-classes';
import { ResearchInfrastructure } from '../../../research-infrastructure/model/research-infrastructure';
import { DYNAMIC_FIELDSET_ANCHOR } from '../../model/dynamic-content/constants';
import { ProviderManager } from '../../utils/provider-manager';

@Component( {
    selector: 'res-research-tab',
    templateUrl: './research-tab.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchTabComponent)],
} )
export class ResearchTabComponent {
    @Input() editMode = true;
    @Input() customContentPanel: boolean = false;
    @Input() dynamicComponent: DynamicComponent;
    @Output() onBeforeNavigate = new EventEmitter();

    @Input() dDKeyProject: string;
    @Input() projects: Project[];
    @Output() projectsChange = new EventEmitter<Project[]>();

    @Input() dDKeyPublication: string;
    @Input() publicationsAreOptional: boolean;
    @Input() publications: Publication[];
    @Output() publicationsChange = new EventEmitter<Publication[]>();

    @Input() dDKeyDoctorates: string;
    @Input() doctorates: Habilitation[];
    @Output() doctoratesChange = new EventEmitter<Habilitation[]>();

    @Input() dDKeyResearchInfrastructures: string;
    @Input() researchInfrastructures: ResearchInfrastructure[];
    @Output() researchInfrastructuresChange = new EventEmitter<ResearchInfrastructure[]>();

    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } ) fieldsetViewContainerList: QueryList<ViewContainerRef>;

    constructor( public auth: HisAuthService ) { }
        
    onProjectsChange( event: Project[] ) {
        this.projectsChange.emit( event );
    }

    onPublicationsChange( event: Publication[] ) {
        this.publicationsChange.emit( event );
    }

    onDoctoratesChange( event: Habilitation[] ) {
        this.doctoratesChange.emit( event );
    }

    onInfrastructuresChange(event: ResearchInfrastructure[] ) {
        this.researchInfrastructuresChange.emit(event);
    }
    
    hasRightsForResearchInfrastructure(): boolean{
        return this.auth.hasAny('RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_EDIT_RESEARCH_INFRASTRUCTURE',
            'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_VIEW_RESEARCH_INFRASTRUCTURE' );
    }
}
